import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { isValidEmailAddress } from 'utils/misc';

import TextField from '@mui/material/TextField';

type Props = {
  value?: string;
  required?: true;
  setEmailValue: (email: string) => void;
};

export default function EmailField({ value, required, setEmailValue }: Props) {
  const { t } = useTranslation('common');
  const [emailAddress, setEmailAddress] = useState(value || '');
  const [isEmailAddressValid, setIsEmailAddressValid] = useState(
    value ? isValidEmailAddress(value) : true
  );

  return (
    <TextField
      value={emailAddress}
      label={t('email')}
      className="email-field"
      fullWidth
      helperText={
        !!emailAddress && !isEmailAddressValid ? t('invalidEmailAddress') : null
      }
      error={!!emailAddress && !isEmailAddressValid}
      onChange={({ target }) => {
        const { value } = target;
        setEmailAddress(value);
        if (isValidEmailAddress(value)) {
          setIsEmailAddressValid(true);
          setEmailValue(value);
        } else {
          setEmailValue('');
        }
      }}
      onBlur={(e) => {
        setIsEmailAddressValid(isValidEmailAddress(e.target.value));
      }}
      required={required}
    />
  );
}
